import React from 'react';
import { Route } from 'react-router';

import App from './containers/App/App';
import { getViewComponents, fieldSummaryComponents } from './utils/routes';

const getComponents = (nextState, callback) => {
  const { layers } = nextState.params;
  const layersArray = layers.split('|');
  const components = layersArray.reduce((_components, layer, index) => {
    const layerLabel = !index ? 'Main' : 'Split';
    const { mapLayer, panel, legend, content, modal } = getViewComponents(layer);

    return {
      ..._components,
      [`mapLayer${layerLabel}`]: mapLayer,
      [`panel${layerLabel}`]: panel,
      [`legend${layerLabel}`]: legend,
      [`modal${layerLabel}`]: modal,
      content, // content only applies to the master view.
    };
  }, {});

  callback(null, components);
};

export default (path = "/") => (
  <Route component={App} path={path}>
    <Route path=":fieldId(/)" components={fieldSummaryComponents} />
    <Route path=":fieldId/:seasonId(/)" components={fieldSummaryComponents} />
    <Route path=":fieldId/:seasonId">
      <Route path=":layers" getComponents={getComponents} />
    </Route>
    <Route path="*" components={fieldSummaryComponents} />
  </Route>
);
